import {differenceInHours, parseISO} from 'date-fns';
import {match, Pattern} from 'ts-pattern';

import {always, isNil} from 'ramda';

import {RentalOrderResponseBody} from '@dms/api/rental';
import {RentalPriceGroupItemResponseBody} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

type CalculateRentPriceReturnBody = {
  dailyRate: number;
  paidDays: number;
  freeDailyKilometers: number;
  totalFreeKilometers: number;
};

export const calculateRentPrice = (
  priceGroupItem: RentalPriceGroupItemResponseBody | Nullish,
  rentalOrder: RentalOrderResponseBody | Nullish,
  actualReturnDate: Date | Nullish
): Partial<CalculateRentPriceReturnBody> => {
  if (isNil(priceGroupItem) || isNil(rentalOrder)) {
    return {
      dailyRate: 0,
      paidDays: 0,
      freeDailyKilometers: 0,
      totalFreeKilometers: 0,
    };
  }

  const freeDailyKilometers = priceGroupItem.price?.includedKilometers;
  const dailyRate = parseFloat(priceGroupItem.price?.rate);

  const paidDays = match([
    rentalOrder?.plannedRentalPeriod?.to,
    rentalOrder?.plannedRentalPeriod?.from,
  ])
    .with([Pattern.string, Pattern.string], ([toIso, fromIso]) => {
      const to = parseISO(toIso);
      const from = parseISO(fromIso);

      const diffHours = differenceInHours(actualReturnDate ?? to, from);
      return Math.ceil(diffHours / 24);
    })
    .otherwise(always(0));

  const totalFreeKilometers = freeDailyKilometers * paidDays;

  return {
    dailyRate,
    paidDays,
    freeDailyKilometers,
    totalFreeKilometers,
  };
};
